import { ReactNode, useEffect, useRef, useState } from "react"
import { Container, HStack, Stack, VStack } from "rsuite"
import { LogoIcon } from "./SvgLoader"
import Ufo from "./Ufo"
import Version from "./Version"
import LanguageSwitcher from "./LanguageSwitcher"
import { BuildInfoType, getBuildInfo } from "../config/constants"

const companyStyle: React.CSSProperties = {
    position: 'fixed',
    top: '93vh',
    width: 'min(20em, 100%)',
    height: '10vh',
    alignItems: 'center',
    justifyContent: 'center',
    // outline: '1px solid red',
}
const childrenStyle: React.CSSProperties = {
    zIndex: 1,
}
const logoStyle: React.CSSProperties = {
    fill: 'hsl(200deg 100% 54.62%)',
    width: '3em',
}
const linkStyle: React.CSSProperties = {
    color: 'hsl(200deg 100% 54.62%)',
}

const Company = () => {
    const year = new Date().getFullYear();
    return (
        <Container style={companyStyle}>
            <HStack spacing={15}>
                <LogoIcon style={logoStyle} link="/" />
                <Stack.Item>
                    © {year} by <a target="_blank" href="https://deja.ltd" style={linkStyle}>deja.ltd</a>
                </Stack.Item>
            </HStack>
        </Container>
    )
}

type OverlayProps = { children: ReactNode }
export default function Overlay({ children }: OverlayProps) {
    const [info, setInfo] = useState<BuildInfoType | null>(null)
    const styleRef = useRef<React.CSSProperties>({ top: '1.5em' })

    useEffect(() => {
        const _ = async () => {
            const _info = await getBuildInfo()
            styleRef.current = { top: _info.isDaily || _info.isDemo ? '3em' : '1.5em' }
            setInfo(_info)
        }
        _()
    }, [])

    return (
        <>
            <div className="overlay overlay-1060 background-image">
                <LanguageSwitcher style={styleRef.current} />
                <Container style={childrenStyle}>
                    {children}
                </Container>
                <Company />
                <Version />
                <Ufo />
            </div>
        </>
    )
}